import React from "react";

type Props = {
  isOn: boolean;
  withLetter?: boolean;
  disabled?: boolean;
  onToggle: (isOn: boolean) => void;
  style?: React.CSSProperties;
};

const SwitchButton = ({ isOn, withLetter = false, onToggle, style, disabled = false }: Props) => {
  const offLetter = (
    <path
      d="M31.2409 15.8164C31.2409 14.3906 31.6237 13.2754 32.3893 12.4707C33.155 11.6621 34.1432 11.2578 35.3542 11.2578C36.1471 11.2578 36.862 11.4473 37.4987 11.8262C38.1354 12.2051 38.6198 12.7344 38.9518 13.4141C39.2878 14.0898 39.4557 14.8574 39.4557 15.7168C39.4557 16.5879 39.28 17.3672 38.9284 18.0547C38.5768 18.7422 38.0788 19.2637 37.4342 19.6191C36.7897 19.9707 36.0944 20.1465 35.3483 20.1465C34.5397 20.1465 33.8171 19.9512 33.1803 19.5605C32.5436 19.1699 32.0612 18.6367 31.7331 17.9609C31.405 17.2852 31.2409 16.5703 31.2409 15.8164ZM32.4128 15.834C32.4128 16.8691 32.6901 17.6855 33.2448 18.2832C33.8034 18.877 34.5026 19.1738 35.3425 19.1738C36.1979 19.1738 36.901 18.873 37.4518 18.2715C38.0065 17.6699 38.2839 16.8164 38.2839 15.7109C38.2839 15.0117 38.1647 14.4023 37.9264 13.8828C37.6921 13.3594 37.3464 12.9551 36.8893 12.6699C36.4362 12.3809 35.9264 12.2363 35.36 12.2363C34.5553 12.2363 33.862 12.5137 33.28 13.0684C32.7018 13.6191 32.4128 14.541 32.4128 15.834ZM40.985 20V11.4102H46.78V12.4238H42.1217V15.084H46.153V16.0977H42.1217V20H40.985ZM48.321 20V11.4102H54.1159V12.4238H49.4577V15.084H53.4889V16.0977H49.4577V20H48.321Z"
      fill="white"
    />
  );
  const onLetter = (
    <path
      d="M12.9075 15.8164C12.9075 14.3906 13.2904 13.2754 14.056 12.4707C14.8216 11.6621 15.8099 11.2578 17.0208 11.2578C17.8138 11.2578 18.5286 11.4473 19.1654 11.8262C19.8021 12.2051 20.2864 12.7344 20.6185 13.4141C20.9544 14.0898 21.1224 14.8574 21.1224 15.7168C21.1224 16.5879 20.9466 17.3672 20.595 18.0547C20.2435 18.7422 19.7454 19.2637 19.1009 19.6191C18.4564 19.9707 17.7611 20.1465 17.015 20.1465C16.2064 20.1465 15.4837 19.9512 14.847 19.5605C14.2103 19.1699 13.7279 18.6367 13.3997 17.9609C13.0716 17.2852 12.9075 16.5703 12.9075 15.8164ZM14.0794 15.834C14.0794 16.8691 14.3568 17.6855 14.9114 18.2832C15.47 18.877 16.1693 19.1738 17.0091 19.1738C17.8646 19.1738 18.5677 18.873 19.1185 18.2715C19.6732 17.6699 19.9505 16.8164 19.9505 15.7109C19.9505 15.0117 19.8314 14.4023 19.5931 13.8828C19.3587 13.3594 19.013 12.9551 18.556 12.6699C18.1029 12.3809 17.5931 12.2363 17.0267 12.2363C16.222 12.2363 15.5286 12.5137 14.9466 13.0684C14.3685 13.6191 14.0794 14.541 14.0794 15.834ZM22.5814 20V11.4102H23.7474L28.2591 18.1543V11.4102H29.3489V20H28.1829L23.6712 13.25V20H22.5814Z"
      fill="white"
    />
  );
  var btnOff = (
    <svg
      data-testid="switch-button-off"
      width="64"
      height="32"
      viewBox="0 0 64 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: "block", margin: "auto", ...style }}
    >
      <rect x="0.5" y="0.5" width="63" height="31" rx="15.5" fill="#A8A8A8" stroke="#303030" />
      <circle cx="16" cy="16" r="11.5" fill="white" stroke="#303030" />
      {withLetter ? offLetter : null}
    </svg>
  );
  var btnOn = (
    <svg
      data-testid="switch-button-on"
      width="64"
      height="32"
      viewBox="0 0 64 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: "block", margin: "auto", ...style }}
    >
      <rect x="0.5" y="0.5" width="63" height="31" rx="15.5" fill="#E38006" stroke="#303030" />
      <circle cx="48" cy="16" r="11.5" fill="white" stroke="#303030" />
      {withLetter ? onLetter : null}
    </svg>
  );

  return (
    <div data-testid="switch-button" style={{ cursor: "pointer", ...style }} onClick={disabled ? () => {} : () => onToggle(!isOn)}>
      {isOn ? btnOn : btnOff}
    </div>
  );
};
export default SwitchButton;
